export const escapeQuery = (value: String) => {
  return value
    .replace(/[<>]/g, ``)
    .replace(/([+\-=&|><!(){}[\]^"~*?:\\/])/g, '\\$1')
    .replace(/\s/g, '\\ ');
};

export const buildSearchFilter = (
  query: string,
  fields: string | string[],
): string => {
  const escapedQuery = escapeQuery(query);
  const fieldList = Array.isArray(fields) ? fields : [fields];
  const conditions = fieldList.map(field => `${field}:*${escapedQuery}*`);
  return conditions.length > 1 ? `(${conditions.join(' OR ')})` : conditions[0];
};
